import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5d569fab&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=5d569fab&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d569fab",
  null
  
)

export default component.exports